// Query keys for billing (Stripe subscriptions). Shared by the user-facing
// billing hooks and the admin billing pages so invalidation from either side
// hits the same cache entries. Pattern follows ui/src/lib/query/keys.ts.
export const billingKeys = {
  config: () => ["billing", "config"] as const,
  plans: () => ["billing", "plans"] as const,
  subscription: (orgId?: string) => ["billing", "subscription", orgId ?? "me"] as const,
  changePlanPreview: (planSlug: string) => ["billing", "changePlanPreview", planSlug] as const,
  admin: {
    plans: () => ["billing", "admin", "plans"] as const,
    orgSubscription: (orgId: string) => ["billing", "admin", "orgSubscription", orgId] as const,
  },
};
